import SEO from "../../components/shared/SEO";
import { Link, useNavigate } from 'react-router-dom';

export default function RefundPolicy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] text-gray-400 font-sans p-6 md:p-20 relative overflow-hidden">
      <SEO title="Refund Policy" description="Refunds, cancellations, and support protocols." />
      
      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-[10px] font-black uppercase tracking-[0.3em] text-orange-500 mb-8 block transition-opacity hover:opacity-80">← Back</button>
        <h1 className="text-4xl md:text-7xl font-black text-white mb-8 tracking-tighter uppercase leading-none">Refund <span className="text-orange-500">Policy</span></h1>
        
        <p className="text-lg text-gray-300 font-medium leading-relaxed mb-12 max-w-2xl">
          At EnvDock, I want you to be 100% satisfied with your purchase. As a solo developer, I value your support and aim to provide the best experience possible.
        </p>
        
        <div className="bg-white/[0.02] border border-white/5 rounded-[3rem] p-8 md:p-16 space-y-16">
          
          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">01. 14-Day Money-Back Guarantee</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                If EnvDock doesn't meet your expectations, I offer a full refund within 14 days of your initial purchase. No hard feelings!
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">02. How to Request a Refund</h3>
            <div className="p-6 bg-orange-500/5 border border-orange-500/10 rounded-[2rem] my-4">
                <p className="text-orange-500 text-[10px] font-black uppercase tracking-widest mb-2">Important Notice</p>
                <p className="text-sm text-gray-300 font-medium leading-relaxed">
                    Please do not contact your bank or credit card provider first. Bank disputes (chargebacks) can take up to 90 days to resolve. Emailing me directly is the fastest way to get your money back (usually within 3–5 business days).
                </p>
            </div>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                I process all refund requests within 24–48 hours. To initiate this, simply email me with your Order ID (from your Lemon Squeezy receipt) and the email address used for the purchase.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">03. Subscription Cancellations</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                You can cancel your subscription at any time through the "Billing" section in the app or by clicking the "Manage Subscription" link in your Lemon Squeezy receipt email. Once cancelled, you will not be charged again, but you will retain access until the end of your current billing period.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">04. Technical Issues</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                If you are requesting a refund because something isn't working, please let me know! I am happy to jump in and fix any bugs for you immediately.
            </p>
          </div>

          <div className="p-8 bg-black/40 border border-white/5 rounded-3xl font-mono text-[11px] uppercase tracking-tighter text-gray-500 leading-relaxed">
             [CONTACT PROTOCOL] To request a refund, report a bug, or get help, transmit a secure message to <a href="mailto:envdock@gmail.com" className="text-white hover:text-orange-500 transition-colors">envdock@gmail.com</a>.
          </div>
          
        </div>
      </div>
    </div>
  );
}